// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.donut-score[data-v-a2bd1a3e] {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.donut-bg[data-v-a2bd1a3e] {\n  opacity: 0.3;\n}\n.donut-value[data-v-a2bd1a3e] {\n  transition: stroke-dashoffset 0.6s cubic-bezier(0.4, 0, 0.2, 1);\n}\n.score-text[data-v-a2bd1a3e] {\n  font-weight: bold;\n  fill: #222;\n  dominant-baseline: middle;\n}\n.rating-text[data-v-a2bd1a3e] {\n  fill: #666;\n  dominant-baseline: middle;\n}\n", ""]);
// Exports
module.exports = exports;
